import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button, message, Card } from 'antd';
import styled from 'styled-components';
import { generateAuthCode } from '../redux/reducers/utils/authReducer';
import PhoneInput from '../ui/PhoneInput';

const GenerateAuthCodeComponent = () => {
  const [generatedCode, setGeneratedCode] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { generateAuthCodeStatus } = useSelector((store) => store.auth);

  const handleSubmit = async (values) => {
    try {
      const action = await dispatch(generateAuthCode(values.phone));
      
      if (action.meta.requestStatus === 'fulfilled') {
        const code = action.payload?.code;
        if (code) {
          setGeneratedCode(code);
          message.success('Код успешно сгенерирован!');
        } 
      } else {
        console.log(action.payload?.message || 'Ошибка при генерации кода');
      }
    } catch (error) {
      console.error('Error generating auth code:', error);
      message.error('Произошла ошибка');
    }
  };

  return (
    <CenterWrapper>
      <StyledCard title="Генерация кода авторизации">
        <StyledForm
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            label="Номер телефона"
            name="phone"
            rules={[
              { required: true, message: 'Введите номер телефона' },
              { 
                pattern: /^\+?[1-9]\d{10,14}$/,
                message: 'Введите корректный номер телефона'
              }
            ]}
          >
            <PhoneInput placeholder="+7 (999) 999-99-99" />
          </Form.Item>

          {generatedCode && (
            <CodeDisplay>
              <CodeLabel>Ваш код:</CodeLabel>
              <CodeValue>{generatedCode}</CodeValue>
            </CodeDisplay>
          )}

          <ButtonWrapper>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={generateAuthCodeStatus === 'pending'}
            >
              Сгенерировать код
            </Button>
          </ButtonWrapper>
        </StyledForm>
      </StyledCard>
    </CenterWrapper>
  );
};

export default GenerateAuthCodeComponent;

const CenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 20px;
`;

const StyledCard = styled(Card)`
  width: 100%;
  max-width: 500px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  
  .ant-card-head {
    background: #ffffff;
    border-bottom: 1px solid #e8e8e8;
    
    .ant-card-head-title {
      color: #262626;
      font-size: 16px;
      font-weight: 600;
    }
  }
`;

const StyledForm = styled(Form)`
  .ant-form-item-label > label {
    font-size: 14px;
    font-weight: 500;
    color: #262626;
  }
  
  .ant-input {
    border-radius: 4px;
  }
`;

const CodeDisplay = styled.div`
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 24px;
  margin-bottom: 20px;
  text-align: center;
`;

const CodeLabel = styled.div`
  font-size: 14px;
  color: #595959;
  margin-bottom: 12px;
  font-weight: 500;
`;

const CodeValue = styled.div`
  font-size: 36px;
  font-weight: 600;
  color: #262626;
  letter-spacing: 10px;
  font-family: 'Courier New', monospace;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  
  button {
    min-width: 120px;
  }
`;
